import { create } from 'zustand'

export const useCalendarEventsStore = create((set) => ({
    events: [
        {
            title: 'Event 1',
            description: 'Test 1',
            start: new Date(),
            end: new Date(new Date().setHours(new Date().getHours() + 1)),
            date: "2023-05-23",
            duration: "2",
            time: "9:11",
            room: "meeting room",
            members: "",
            department: "2",
            responsible: "Sabina",
            type: ""
        },
        {
            title: 'Event 2',
            start: new Date(new Date().setDate(new Date().getDate() + 1)),
            end: new Date(new Date().setDate(new Date().getDate() + 1)),
        },
        {
            title: "Test event 111",
            start: new Date(new Date().setDate(new Date().getDate() + 2)),
            end: new Date(new Date().setDate(new Date().getDate() + 2)),
            description: "Test event 111",
            date: "2023-05-23",
            duration: "4",
            time: "11:11",
            room: "meeting room",
            members: "",
            department: "3",
            responsible: "Oybek",
            type: ""
        }
    ],
    setEvents: (data) => set((state)=> ({events: [...state.events, data]})),
}))